
const aboutlendingjan26 = {
    "About Lendingkart Jan'26": [
        {
            question: "What are the important details of the Bond offering?",
            answer: "Issuer Name: Lendingkart Finance Limited (LFL)" + "<br>" +
            "Security Name: 11.25% NCD Lendingkart Finance Ltd January 2026" + "<br>" +
            "ISIN:INE090W07667"+ "<br>" +
            "Nature of Instrument: Senior, secured, rated, listed, redeemable, taxable, non-convertible debentures" + "<br>" +
            "Seniority: Senior" + "<br>" +
            "Date of Issue: 30th January 2024" + "<br>" +
            "Credit Rating: ICRA BBB+/Positive" + "<br>" +
            "Face Value: Rs 1,00,000/Unit" + "<br>" +
            "Coupon: Fixed" + "<br>" +
            "Coupon Rate: 11.25% p.a." + "<br>" +
            "Coupon Frequency: Monthly"+ "<br>" +
            "Principal Repayment: At Maturity" + "<br>" +
            "Original Mode of Issue: Private Placement" + "<br>" +
            "Listing Details: Bombay Stock Exchange (BSE)" + "<br>" +
            "Maturity Date: 30th Jan’2026" + "<br>" +
            "Tenor: 24 months" + "<br>" +
            "Debenture Trustee: Catalyst Trusteeship Limited"
                
            },

            {
                question: "What is the Security Cover for the Bond?",
                answer: "The Bond is secured by way of a first ranking, exclusive and continuing charge on identified loan receivables for 1.1x the outstanding amount of the Bond (including Interest accrued)."
            },
            {
                question: "What are the important covenants that the Issuer has to adhere to?",
                answer: "a. The Capital Adequacy Ratio (Tier 1 and Tier 2 capital) shall not fall below 20%." + "<br>" +
                "b. Debt to Equity should not exceed 4 times." + "<br>" +
                "c. Gross Non-Performing Assets as a % of average portfolio of the Company shall not increase beyond 5%" + "<br>" +
                "d. NNPA should be less than 3.50%" + "<br>" +
                "e. Cumulative Asset Liability mismatch should always be positive in all the buckets" + "<br>" +
                "f. PBT should be positive on annual basis"
            },
            {
                question: "Can I liquidate the bond before maturity?",
                answer: "Yes, you can liquidate the bond before maturity through our anytime liquidation feature. However, the liquidation will happen at a discount of 2% to the value of the bond."
            },
            {
                question: "How is the Yield to Maturity (YTM) is calculated?",
                answer: "The Yield to Maturity is calculated using the XIRR formula present in Microsoft Excel or such other spreadsheets. The cash flow is populated in the spreadsheet along with the dates and the XIRR formula is then applied to get the YTM."
            }


    ]
  }
  
  export default aboutlendingjan26;